import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../locales/translations';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { RootState } from '../../../store/store';
import { AwarenessCampaignsActions } from '../../../store/reducers/awareness_campaigns/list';
import ChipFilterButton from '../../_include/Buttons/ChipFilterButton';

const CompletedMissionsFilter = () => {
    const { t } = useTranslation([Namespace.ADDRESSES]);
    const dispatch = useAppDispatch();
    const showAmbassadorCompleted = useAppSelector((state: RootState) => state.awareness_campaign.list.showAmbassadorCompleted);

    const handleToggle = () => {
        dispatch(AwarenessCampaignsActions.toggleShowAmbassadorCompleted());
    };

    return (
        <ChipFilterButton 
            label={t('show_my_completed_missions', { ns: Namespace.ADDRESSES })}
            onToggle={handleToggle}
            isActive={showAmbassadorCompleted}
        />
    );
};

export default CompletedMissionsFilter; 